import React, {useState, useEffect, lazy, Suspense} from 'react';
import PropTypes from 'prop-types';
import { Constants } from '../../adapters/helpers/Constants';
//const AvatarComponent = lazy(() => import('./AvatarComponent'));
import BreadCrumbSEO from '../SEOschema/BreadCrumbSEO';
import { getBreadcrumbsBySlug } from '../../adapters/helpers/getBreadcrumbsBySlug';
import { mediaQueryHOC } from '../../adapters/helpers/Hooks';

const BreadCrumbs = ({breadcrumbs}) => {
  const [hasBreadcrumb, setHasBreadcrumb] = useState(false);
  const [breadCrumbValue, setBreadCrumbValue] = useState([]);
  
  useEffect(() => {
    let pathName = window?.location?.pathname;
    async function fetchData() {
      const breadCrumbsValue = await getBreadcrumbsBySlug(pathName)
        if(breadCrumbsValue && breadCrumbsValue.length > 1){
          setHasBreadcrumb(true)
          setBreadCrumbValue(breadCrumbsValue)
        }        
      }
      fetchData();
      let productSubNavEle = document.getElementById('ob-product-subnav-scroll');
      let headerEle = document.getElementsByClassName('zone-header');

      if(!productSubNavEle && headerEle) {
          headerEle[0].style.position = 'fixed';
      }
  }, []);
       
  return (
    <React.Fragment>
      {hasBreadcrumb && breadCrumbValue ? <React.Fragment><nav className="breadcrumb-main" aria-label={Constants.breadCrumpLabel} id="breadcrumb-main">
        <ul className="breadcrumb" itemScope aria-label="Breadcrumbs">
          {breadCrumbValue &&
            breadCrumbValue.map((val, key) => {
              return (
                <li key={key}>
                  {val.linkUrl ? (
                    <a aria-label={`${Constants.breadCrumpLabel}-${val.pageTitle}`} href={val.linkUrl}>{val.pageTitle}</a>
                  ) : (
                    <span className="activeMenu">{val.pageTitle}</span>
                  )}
                </li>
              );
            })}
        </ul>
      </nav>
      <BreadCrumbSEO breadcrumb={breadCrumbValue} />
      </React.Fragment> : <React.Fragment><nav className="breadcrumb-main" aria-label={Constants.breadCrumpLabel} id="breadcrumb-main">
        <ul className="breadcrumb" itemScope aria-label="Breadcrumbs">
          <li>
            <span className="op-breadcrumb-loading">{Constants.Loading}</span>        
          </li>
        </ul>
    </nav>
    </React.Fragment>
  }
    </React.Fragment>
  );
};

BreadCrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
};

export default BreadCrumbs;
